import React from 'react';

const PaginationLast = (props) => (
  <svg width="9" height="12" viewBox="0 0 9 12" fill="none" xmlns="http://www.w3.org/2000/svg">
  <g>
  <path d="M0 11.1915V0.808651C0 0.0897103 0.869241 -0.270325 1.3776 0.238034L6.569 5.42943C6.88413 5.74456 6.88413 6.25554 6.569 6.57067L1.3776 11.7621C0.869241 12.2705 0 11.9104 0 11.1915Z" fill={props.color ? props.color : 'white'}/>
  <rect x="6.75" y="6.10352e-05" width="2.25" height="12" rx="0.5" fill={props.color ? props.color : 'white'}/>
  </g>
  </svg>
);

export default PaginationLast;
